import { TableRow } from "@mui/material";
import { StyledTableHeadingCell } from "../../../../../common/components/functional/simpleTable/styled";
import { useTranslation } from "react-i18next";

export const SettingsHeader = () => {
  const { t } = useTranslation("talentProfile");

  return (
    <TableRow>
      <StyledTableHeadingCell>{`${t("from")} (*)`}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{t("to")}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{`${t("mode")} (*)`}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{t("min")}</StyledTableHeadingCell>
      <StyledTableHeadingCell>{t("max")}</StyledTableHeadingCell>
      <StyledTableHeadingCell />
    </TableRow>
  );
};
